import React, { useState, useEffect } from "react";
import { Button, Layout, Table } from "antd";
import axios from "axios";
import { LoadingOutlined } from "@ant-design/icons";
import ENVIRONMENT from "../../../../environments";

const { Header, Content, Footer } = Layout;

function Agencies(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [agencies, setAgencies] = useState([]);
  const [agencyName, setAgencyName] = useState(null);
  const [inviteAgencyArtist, setInviteAgencyArtist] = useState(false);
  const [viewInvoice, setViewInvoice] = useState(false);
  const [artistUsernames, setArtistUsernames] = useState([]);

  useEffect(() => {
    setIsLoading(true);
    axios.post(ENVIRONMENT.AGENCY_GET_BATCH, {}).then((res) => {
      if (res["data"]) {
        setAgencies(res["data"]);
      }
      setIsLoading(false);
    });
  }, []);

  const viewAgencyDetails = (agency_id) => {};

  const columns = [
    {
      title: "Agency Name",
      key: 1,
      dataIndex: "agency_name",
    },
    {
      title: "Agency Admin",
      key: 2,
      dataIndex: "admin_username",
    },
    {
      title: "",
      key: 3,
      dataIndex: "id",
      render: (text) => (
        <span>
          <a href={'/admin_agency_details/'+text}>View Agency Details</a>
        </span>
      ),
    },
  ];

  return (
    <React.Fragment>
      <Table
        columns={columns}
        dataSource={agencies}
        bordered={true}
        loading={{
          indicator: <LoadingOutlined />,
          spinning: isLoading,
        }}
      />
    </React.Fragment>
  );
}

export default Agencies;
